import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faInstagramSquare,
} from "@fortawesome/free-brands-svg-icons";

interface Props {
  Class: string;
  Type: string;
}

export const SocialMedia = (props: Props): any => {
  return props.Type === "Header" ? (
    <div className={props.Class}>
      <span>
        <a
          href="https://www.facebook.com/hannakacinielart/"
          title="facebook"
          target="_blank"
          rel="noreferrer"
        >
          <FontAwesomeIcon icon={faFacebookSquare} size="2x" />
        </a>
      </span>
      <span>
        <a
          href="https://www.instagram.com/hannakacinielart/"
          title="instagram"
          target="_blank"
          rel="noreferrer"
        >
          <FontAwesomeIcon icon={faInstagramSquare} size="2x" />
        </a>
      </span>
    </div>
  ) : (
    <div className={props.Class}>
      <a
        href="https://www.facebook.com/hannakacinielart/"
        title="facebook"
        target="_blank"
        rel="noreferrer"
      >
        <FontAwesomeIcon icon={faFacebookSquare} size="2x" />
      </a>

      <a
        href="https://www.instagram.com/hannakacinielart/"
        title="instagram"
        target="_blank"
        rel="noreferrer"
      >
        <FontAwesomeIcon icon={faInstagramSquare} size="2x" />
      </a>
    </div>
  );
};
